import { getters } from "./getters"
import { mutations } from "./mutations"
import { actions } from "./actions"

const state = {
    meta: {
        baruCount: 0,
        // prosesCount: 0,
        pendingCount: 0,
        selesaiCount: 0,
        batalCount: 0,
        allCount: 0,
        currentPage: 1,
        perPage: 10
    },
    selectedTabIndex: 'Baru',
    records: {},
    wo_summary: {},
    wo_global: [],
    report: {},
    summary: {},
    customers: [],
    metric: {},
    statuses: [],
    sortOrder: [],
    uiFlags: {
        isFetching: false,
        isFetchingItem: false,
        isUpdating: false,
        isUpdatingUnreadCount: false,
        isCreating: true,
        isFetchingAudit: false,
        isFetchingSummary: false,
        isFetchingCustomer: false,
        isDownloadingReport: false,
        isFetchingWorkOrderSummary: false,
        isFetchingWorkOrderGlobal: false,
    },
    bulkEditModal: {
        selectedComplaints: []
    },
    issues: [],
    audits: []
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
